import { signal } from "@preact/signals-react";

import { EllipsisVerticalIcon } from "components/Icons";
import Popover from "componentsv2/widgets/Popover";

const OptionsCard = ({ deployCard }) => {
  const show = signal(false);
  return (
    <div className="relative left-0 top-1/2 -translate-y-1/2 max-w-max z-10">
      <button
        type="button"
        className="cursor-pointer !-mr-3"
        onClick={() => (show.value = !show.value)}
      >
        <EllipsisVerticalIcon className="h-3 text-gray-500 fill-current" />
      </button>
      <Popover
        show={show}
        classNameContainer={"right-full"}
        className={"p-0! overflow-hidden"}
      >
        <ul className="min-w-max text-gray-800">
          <li className="hover:bg-gray-800 px-4 py-2 hover:text-white ">
            Pasar a siguiente estado
          </li>
          <li className="hover:bg-gray-800 px-4 py-2 hover:text-white ">
            Ver orden
          </li>
          <li
            className="hover:bg-gray-800 px-4 py-2 hover:text-white "
            onClick={() => (deployCard.value = !deployCard.value)}
          >
            Desplegar
          </li>
        </ul>
      </Popover>
    </div>
  );
};

export default OptionsCard;
